module.exports = __webpack_public_path__ + "static/media/play-1.cee0c54f.svg";